import { render, staticRenderFns } from "./ColonyRow.vue?vue&type=template&id=70010361"
import script from "./ColonyRow.vue?vue&type=script&lang=ts"
export * from "./ColonyRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports